import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/shell/ProtectedRoute";
import AppShell from "@/components/shell/AppShell";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import ConsumerJourneyPortal from "@/pages/ConsumerJourneyPortal";
import WalletHome from "@/pages/wallet/WalletHome";
import WalletOnboarding from "@/pages/wallet/WalletOnboarding";
import WalletProductReviews from "@/pages/wallet/WalletProductReviews";
import WalletDocuments from "@/pages/wallet/WalletDocuments";
import WalletInstitutions from "@/pages/wallet/WalletInstitutions";
import WalletInstitutionDetail from "@/pages/wallet/WalletInstitutionDetail";
import WalletCheckInteractionComingNext from "@/pages/wallet/WalletCheckInteractionComingNext";
import InstitutionPortalDemo from "@/pages/institution/InstitutionPortalDemo";
import WalletRecord from "@/pages/wallet/WalletRecord";
import WalletSafety from "@/pages/wallet/WalletSafety";
import WalletLifeJourneys from "@/pages/wallet/WalletLifeJourneys";
import WalletAssistanceList from "@/pages/wallet/WalletAssistanceList";
import WalletAssistanceWizard from "@/pages/wallet/WalletAssistanceWizard";
import WalletDemosPage from "@/pages/wallet/WalletDemosPage";
import WalletInvestmentsHub from "@/pages/wallet/WalletInvestmentsHub";
import WalletInvestmentScenario from "@/pages/wallet/WalletInvestmentScenario";
import WalletBranchTrustPackageDemo from "@/pages/wallet/WalletBranchTrustPackageDemo";
import WalletInstitutionApiKeyDemo from "@/pages/wallet/WalletInstitutionApiKeyDemo";
import WalletAbcWealthProposalDemo from "@/pages/wallet/WalletAbcWealthProposalDemo";
import WalletAltaraTrustVerifyDemo from "@/pages/wallet/WalletAltaraTrustVerifyDemo";
import WalletAltaraUnderstandDemo from "@/pages/wallet/WalletAltaraUnderstandDemo";
import WalletAltaraCheckActDemo from "@/pages/wallet/WalletAltaraCheckActDemo";
import WalletAltaraComplaintDemo from "@/pages/wallet/WalletAltaraComplaintDemo";
import WalletAltaraTrustCheckScamDemo from "@/pages/wallet/WalletAltaraTrustCheckScamDemo";
import WalletAltaraPrologueDemo from "@/pages/wallet/WalletAltaraPrologueDemo";
import WalletAltaraProofDemo from "@/pages/wallet/WalletAltaraProofDemo";
import WalletAltaraClosingDemo from "@/pages/wallet/WalletAltaraClosingDemo";
import NomsaNoiseDemo from "@/pages/wallet/NomsaNoiseDemo";
import NomsaNoiseOrbitDemo from "@/pages/wallet/NomsaNoiseOrbitDemo";
import NomsaThoughtsDemo from "@/pages/wallet/NomsaThoughtsDemo";
import NomsaActionsDemo from "@/pages/wallet/NomsaActionsDemo";
import NomsaMeetDemo from "@/pages/wallet/NomsaMeetDemo";
import AltaraStoryMode from "@/pages/wallet/AltaraStoryMode";
import AltaraJourneyIntroDemo from "@/pages/wallet/AltaraJourneyIntroDemo";
import VoiceAuditionPage from "@/pages/VoiceAuditionPage";
import AltaraUnderstandV2Demo from "@/pages/wallet/AltaraUnderstandV2Demo";
import AltaraTransitionDemo from "@/pages/wallet/AltaraTransitionDemo";
import JudgesAssetHub from "@/pages/JudgesAssetHub";
import InboxDepositPage from "@/pages/InboxDepositPage";
import TrustCertificateVerifyPage from "@/pages/TrustCertificateVerifyPage";
import TrustCertificateDemoPage from "@/pages/TrustCertificateDemoPage";
import TechSprintDemoPage from "@/pages/TechSprintDemoPage";
import DemosHubPage from "@/pages/DemosHubPage";
import NaviCorpusPage from "@/pages/NaviCorpusPage";
import WalletGlossary from "@/pages/wallet/WalletGlossary";
import WalletDecisionHub from "@/pages/wallet/WalletDecisionHub";
import WalletDecisions from "@/pages/wallet/WalletDecisions";
import WalletDecisionRoom from "@/pages/wallet/WalletDecisionRoom";
import WalletOutcomeEvidence from "@/pages/wallet/WalletOutcomeEvidence";
import WalletFamily from "@/pages/wallet/WalletFamily";
import WalletLearning from "@/pages/wallet/WalletLearning";
import WalletSettings from "@/pages/wallet/WalletSettings";
import WalletLiteracy from "@/pages/wallet/WalletLiteracy";
import WalletProvenance from "@/pages/wallet/WalletProvenance";
import WalletIdentity from "@/pages/wallet/WalletIdentity";
import WalletConsent from "@/pages/wallet/WalletConsent";
import WalletConsentDetail from "@/pages/wallet/WalletConsentDetail";
import WalletConsentClaim from "@/pages/wallet/WalletConsentClaim";
import WalletFinancialProfile from "@/pages/wallet/WalletFinancialProfile";
import WalletAbout from "@/pages/wallet/WalletAbout";
import WalletIntelligencePage from "@/pages/WalletIntelligencePage";
import { AccessibilityProvider } from "@/contexts/AccessibilityContext";
import { TranslationProvider } from "@/contexts/TranslationContext";
import Dashboard from "@/pages/Dashboard";
import Consumers from "@/pages/Consumers";
import ConsumerProfile from "@/pages/ConsumerProfile";
import ConsumerJourneysPage from "@/pages/ConsumerJourneysPage";
import TimelinePage from "@/pages/TimelinePage";
import EvidencePage from "@/pages/EvidencePage";
import RecommendationsPage from "@/pages/RecommendationsPage";
import LearningPage from "@/pages/LearningPage";
import AssessmentsPage from "@/pages/AssessmentsPage";
import ReportsPage from "@/pages/ReportsPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import AdministrationPage from "@/pages/AdministrationPage";
import {
  ConsentLedgerAdminPage,
  KycOrchestrationPage,
  TrustCertificatesAdminPage,
} from "@/pages/admin/TrustUtilityPages";
import InstitutionsConsole from "@/pages/admin/InstitutionsConsole";
// Sprint 6 · Business Capability Model
import ExecutiveOverview from "@/pages/capabilities/ExecutiveOverview";
import ConsumerIntelligenceCapability from "@/pages/capabilities/ConsumerIntelligenceCapability";
import InstitutionWorkspaceCapability from "@/pages/capabilities/InstitutionWorkspaceCapability";
import TrustWorkflowsCapability from "@/pages/capabilities/TrustWorkflowsCapability";
import ConsumerEducationCapability from "@/pages/capabilities/ConsumerEducationCapability";
import GovernanceCapability from "@/pages/capabilities/GovernanceCapability";
import PlatformCapability from "@/pages/capabilities/PlatformCapability";
import RequestsHub from "@/pages/requests/RequestsHub";
import TrustRequestDetailPage from "@/pages/requests/TrustRequestDetailPage";
import WalletTrustRequestsPage from "@/pages/wallet/WalletTrustRequestsPage";
import WalletPassportPage from "@/pages/wallet/WalletPassportPage";
import VerifyCredentialPage from "@/pages/verify/VerifyCredentialPage";
import OutcomeDashboard from "@/pages/governance/OutcomeDashboard";
import ConsumerLoginPage from "@/pages/auth/ConsumerLoginPage";
import EnterpriseLoginPage from "@/pages/auth/EnterpriseLoginPage";
import WorkflowTemplatesPage from "@/pages/workflows/WorkflowTemplatesPage";
import ProvidersPage from "@/pages/platform/ProvidersPage";
import PlatformReadmePage from "@/pages/platform/PlatformReadmePage";
import ReportingDashboard from "@/pages/regulatory/ReportingDashboard";
import OmniSectionPage from "@/pages/regulatory/OmniSectionPage";
import RegulatoryReadmePage from "@/pages/regulatory/RegulatoryReadmePage";
import TenantEntitiesPage from "@/pages/platform/TenantEntitiesPage";
import TrustUtilityDashboard from "@/pages/utility/TrustUtilityDashboard";
import ProviderDetailPage from "@/pages/utility/ProviderDetailPage";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id synchronously during render (not in useEffect)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Public consumer-facing journey — no auth. The signed URL token IS the auth. */}
      <Route path="/j/:token" element={<ConsumerJourneyPortal />} />

      {/* Public advisor drop-off page — no auth. Consumer-issued magic link IS the auth. */}
      <Route path="/x/:token" element={<InboxDepositPage />} />

      {/* Public Trust Certificate verify page — no auth. Signed envelope is the proof. */}
      <Route path="/verify/:certId" element={<TrustCertificateVerifyPage />} />

      {/* Live demo walkthrough — pitch/marketing page */}
      <Route path="/demos" element={<DemosHubPage />} />
      <Route path="/demo/trust-certificate" element={<TrustCertificateDemoPage />} />
      <Route path="/techsprint-demo" element={<TechSprintDemoPage />} />

      {/* Consumer Wallet (Trust Wallet) — public, local-storage backed */}
      <Route path="/wallet" element={<WalletHome />} />
      <Route path="/wallet/onboarding" element={<WalletOnboarding />} />

      {/* New consumer-life IA */}
      <Route path="/wallet/documents" element={<WalletDocuments />} />
      <Route path="/wallet/institutions" element={<WalletInstitutions />} />
      <Route path="/wallet/institutions/coming-next" element={<WalletCheckInteractionComingNext />} />
      <Route path="/wallet/institutions/:id" element={<WalletInstitutionDetail />} />
      <Route path="/institution-portal/:id" element={<InstitutionPortalDemo />} />
      <Route path="/wallet/record" element={<WalletRecord />} />
      <Route path="/wallet/safety" element={<WalletSafety />} />
      <Route path="/wallet/life-journeys" element={<WalletLifeJourneys />} />

      {/* Consumer Assistance — package + transfer to institution */}
      <Route path="/wallet/assistance" element={<WalletAssistanceList />} />
      <Route path="/wallet/assistance/new" element={<WalletAssistanceWizard />} />

      {/* Internal Demo Simulation — wallet-shell wrapped */}
      <Route path="/wallet/demos" element={<WalletDemosPage />} />
      <Route path="/wallet/investments" element={<WalletInvestmentsHub />} />
      <Route path="/wallet/investments/:slug" element={<WalletInvestmentScenario />} />
      <Route path="/wallet/demos/branch-trust-package" element={<WalletBranchTrustPackageDemo />} />
      <Route path="/wallet/demos/institution-api-key" element={<WalletInstitutionApiKeyDemo />} />
      <Route path="/wallet/demos/abc-wealth-proposal" element={<WalletAbcWealthProposalDemo />} />
      <Route path="/wallet/demos/altara-trust-verify" element={<WalletAltaraTrustVerifyDemo />} />
      <Route path="/wallet/demos/altara-understand" element={<WalletAltaraUnderstandDemo />} />
      <Route path="/wallet/demos/altara-check-act" element={<WalletAltaraCheckActDemo />} />
      <Route path="/wallet/demos/altara-complaint" element={<WalletAltaraComplaintDemo />} />
      <Route path="/wallet/demos/altara-trust-check-scam" element={<WalletAltaraTrustCheckScamDemo />} />
      <Route path="/wallet/demos/altara-prologue" element={<WalletAltaraPrologueDemo />} />
      <Route path="/wallet/demos/altara-proof" element={<WalletAltaraProofDemo />} />
      <Route path="/wallet/demos/altara-closing" element={<WalletAltaraClosingDemo />} />
      <Route path="/wallet/demos/nomsa-noise" element={<NomsaNoiseDemo />} />
      <Route path="/wallet/demos/nomsa-noise-orbit" element={<NomsaNoiseOrbitDemo />} />
      <Route path="/wallet/demos/nomsa-thoughts" element={<NomsaThoughtsDemo />} />
      <Route path="/wallet/demos/nomsa-actions" element={<NomsaActionsDemo />} />
      <Route path="/wallet/demos/nomsa-meet" element={<NomsaMeetDemo />} />
      <Route path="/story" element={<AltaraStoryMode />} />
      <Route path="/wallet/story" element={<AltaraStoryMode />} />
      <Route path="/wallet/demos/altara-journey-intro" element={<AltaraJourneyIntroDemo />} />
      <Route path="/voices" element={<VoiceAuditionPage />} />
      <Route path="/wallet/demos/altara-understand-v2" element={<AltaraUnderstandV2Demo />} />
      <Route path="/wallet/demos/altara-transition" element={<AltaraTransitionDemo />} />
      <Route path="/judges" element={<JudgesAssetHub />} />
      <Route path="/wallet/life-journeys/:id" element={<WalletLifeJourneys />} />

      {/* Legacy routes — still work, still linkable */}
      <Route path="/wallet/product-reviews" element={<WalletProductReviews />} />
      <Route path="/dev/corpus" element={<NaviCorpusPage />} />
      <Route path="/wallet/glossary" element={<WalletGlossary />} />
      <Route path="/wallet/scam-shield" element={<Navigate to="/wallet/safety" replace />} />
      <Route path="/wallet/decisions" element={<WalletDecisions />} />
      <Route path="/wallet/decisions/legacy" element={<WalletDecisionHub />} />
      <Route path="/wallet/decisions/:id/outcome-evidence" element={<WalletOutcomeEvidence />} />
      <Route path="/wallet/decisions/:id" element={<WalletDecisionRoom />} />
      <Route path="/wallet/family" element={<WalletFamily />} />
      <Route path="/wallet/learning" element={<WalletLearning />} />
      <Route path="/wallet/literacy" element={<WalletLiteracy />} />
      <Route path="/wallet/settings" element={<WalletSettings />} />
      <Route path="/wallet/provenance" element={<WalletProvenance />} />
      <Route path="/wallet/identity" element={<WalletIdentity />} />

      {/* Consent Ledger (BRD §7.4) */}
      <Route path="/wallet/consent" element={<WalletConsent />} />
      <Route path="/wallet/consent/claim" element={<WalletConsentClaim />} />
      <Route path="/wallet/consent/:consentId" element={<WalletConsentDetail />} />

      {/* Consumer Wallet · Financial Profile */}
      <Route path="/wallet/profile" element={<WalletFinancialProfile />} />
      <Route path="/wallet/about" element={<WalletAbout />} />

      {/* Admin: aggregated wallet-signal intelligence */}
      <Route path="/wallet-intelligence" element={<ProtectedRoute><AppShell><WalletIntelligencePage /></AppShell></ProtectedRoute>} />

      <Route path="/dashboard" element={<ProtectedRoute><AppShell><Dashboard /></AppShell></ProtectedRoute>} />
      <Route path="/consumers" element={<ProtectedRoute><AppShell><Consumers /></AppShell></ProtectedRoute>} />
      <Route path="/consumers/:id" element={<ProtectedRoute><AppShell><ConsumerProfile /></AppShell></ProtectedRoute>} />
      <Route path="/journeys" element={<ProtectedRoute><AppShell><ConsumerJourneysPage /></AppShell></ProtectedRoute>} />
      <Route path="/timeline" element={<ProtectedRoute><AppShell><TimelinePage /></AppShell></ProtectedRoute>} />
      <Route path="/evidence" element={<ProtectedRoute><AppShell><EvidencePage /></AppShell></ProtectedRoute>} />
      <Route path="/recommendations" element={<ProtectedRoute><AppShell><RecommendationsPage /></AppShell></ProtectedRoute>} />
      <Route path="/learning" element={<ProtectedRoute><AppShell><LearningPage /></AppShell></ProtectedRoute>} />
      <Route path="/assessments" element={<ProtectedRoute><AppShell><AssessmentsPage /></AppShell></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><AppShell><ReportsPage /></AppShell></ProtectedRoute>} />
      <Route path="/integrations" element={<ProtectedRoute><AppShell><IntegrationsPage /></AppShell></ProtectedRoute>} />
      <Route path="/administration" element={<ProtectedRoute><AppShell><AdministrationPage /></AppShell></ProtectedRoute>} />

      {/* Trust Utility (BRD §7 — planned admin surfaces) */}
      <Route path="/institutions" element={<ProtectedRoute><AppShell><InstitutionsConsole /></AppShell></ProtectedRoute>} />
      <Route path="/consent-ledger" element={<ProtectedRoute><AppShell><ConsentLedgerAdminPage /></AppShell></ProtectedRoute>} />
      <Route path="/kyc-orchestration" element={<ProtectedRoute><AppShell><KycOrchestrationPage /></AppShell></ProtectedRoute>} />
      <Route path="/trust-certificates" element={<ProtectedRoute><AppShell><TrustCertificatesAdminPage /></AppShell></ProtectedRoute>} />

      {/* Sprint 6 · Business Capability Model — 6 landing pages */}
      <Route path="/executive-overview" element={<ProtectedRoute><AppShell><ExecutiveOverview /></AppShell></ProtectedRoute>} />
      <Route path="/capability/consumer-intelligence"  element={<ProtectedRoute><AppShell><ConsumerIntelligenceCapability /></AppShell></ProtectedRoute>} />
      <Route path="/capability/institution-workspace"  element={<ProtectedRoute><AppShell><InstitutionWorkspaceCapability /></AppShell></ProtectedRoute>} />
      <Route path="/capability/trust-workflows"        element={<ProtectedRoute><AppShell><TrustWorkflowsCapability /></AppShell></ProtectedRoute>} />
      <Route path="/capability/consumer-education"     element={<ProtectedRoute><AppShell><ConsumerEducationCapability /></AppShell></ProtectedRoute>} />
      <Route path="/capability/governance"             element={<ProtectedRoute><AppShell><GovernanceCapability /></AppShell></ProtectedRoute>} />
      <Route path="/capability/platform"               element={<ProtectedRoute><AppShell><PlatformCapability /></AppShell></ProtectedRoute>} />

      {/* Requests — first-class object across Institution Workspace */}
      <Route path="/requests" element={<ProtectedRoute><AppShell><RequestsHub /></AppShell></ProtectedRoute>} />
      <Route path="/requests/new" element={<ProtectedRoute><AppShell><RequestsHub /></AppShell></ProtectedRoute>} />
      <Route path="/trust-requests/:request_id" element={<ProtectedRoute><AppShell><TrustRequestDetailPage /></AppShell></ProtectedRoute>} />

      {/* Consumer Wallet — Trust Requests inbox (public, consumer-scoped) */}
      <Route path="/wallet/requests/:consumer_id" element={<WalletTrustRequestsPage />} />

      {/* Consumer Trust Wallet · My Trust Wallet (premium view) */}
      <Route path="/wallet/passport" element={<WalletPassportPage />} />
      <Route path="/wallet/passport/:consumer_id" element={<WalletPassportPage />} />
      <Route path="/wallet/login" element={<ConsumerLoginPage />} />
      <Route path="/enterprise/login" element={<EnterpriseLoginPage />} />

      {/* Public Trust Credential verification */}
      <Route path="/verify/credential/:token" element={<VerifyCredentialPage />} />
      <Route path="/verify/credential-id/:credential_id" element={<VerifyCredentialPage />} />

      {/* Trust Workflows sub-surfaces */}
      <Route path="/workflows/templates" element={<ProtectedRoute><AppShell><WorkflowTemplatesPage /></AppShell></ProtectedRoute>} />
      <Route path="/workflows/templates/:id" element={<ProtectedRoute><AppShell><WorkflowTemplatesPage /></AppShell></ProtectedRoute>} />
      {/* Legacy workflow primitives redirect to their live pages */}
      <Route path="/workflows/identity"              element={<Navigate to="/wallet/identity" replace />} />
      <Route path="/workflows/affordability"         element={<ProtectedRoute><AppShell><TrustWorkflowsCapability /></AppShell></ProtectedRoute>} />
      <Route path="/workflows/product-understanding" element={<ProtectedRoute><AppShell><TrustWorkflowsCapability /></AppShell></ProtectedRoute>} />
      <Route path="/workflows/learning-requests"     element={<ProtectedRoute><AppShell><TrustWorkflowsCapability /></AppShell></ProtectedRoute>} />

      {/* Platform · Providers marketplace */}
      <Route path="/platform/trust-utility" element={<ProtectedRoute><AppShell><TrustUtilityDashboard /></AppShell></ProtectedRoute>} />
      <Route path="/platform/trust-utility/executions/:execution_id" element={<ProtectedRoute><AppShell><TrustUtilityDashboard /></AppShell></ProtectedRoute>} />
      <Route path="/platform/providers" element={<ProtectedRoute><AppShell><ProvidersPage /></AppShell></ProtectedRoute>} />
      <Route path="/platform/providers/:provider_id" element={<ProtectedRoute><AppShell><ProviderDetailPage /></AppShell></ProtectedRoute>} />
      {/* Platform placeholders — future capabilities land under the Platform capability page */}
      <Route path="/platform/branding"      element={<ProtectedRoute><AppShell><PlatformCapability /></AppShell></ProtectedRoute>} />
      <Route path="/platform/feature-flags" element={<ProtectedRoute><AppShell><PlatformCapability /></AppShell></ProtectedRoute>} />
      <Route path="/platform/health"        element={<ProtectedRoute><AppShell><PlatformCapability /></AppShell></ProtectedRoute>} />
      <Route path="/platform/readme"        element={<ProtectedRoute><AppShell><PlatformReadmePage /></AppShell></ProtectedRoute>} />
      <Route path="/platform/tenants/entities" element={<ProtectedRoute><AppShell><TenantEntitiesPage /></AppShell></ProtectedRoute>} />

      {/* Regulatory Reporting · Umbrella 3 */}
      <Route path="/regulatory/readme"                            element={<ProtectedRoute><AppShell><RegulatoryReadmePage /></AppShell></ProtectedRoute>} />
      <Route path="/regulatory/dashboard"                         element={<ProtectedRoute><AppShell><ReportingDashboard /></AppShell></ProtectedRoute>} />
      <Route path="/regulatory/omni/:period_id/sections/:section_n" element={<ProtectedRoute><AppShell><OmniSectionPage /></AppShell></ProtectedRoute>} />

      {/* Governance placeholders — fall back to capability landing until wired */}
      <Route path="/governance/outcomes" element={<ProtectedRoute><AppShell><OutcomeDashboard /></AppShell></ProtectedRoute>} />
      <Route path="/outcome-monitoring" element={<ProtectedRoute><AppShell><OutcomeDashboard /></AppShell></ProtectedRoute>} />
      <Route path="/cases"              element={<ProtectedRoute><AppShell><GovernanceCapability /></AppShell></ProtectedRoute>} />
      <Route path="/human-reviews"      element={<ProtectedRoute><AppShell><GovernanceCapability /></AppShell></ProtectedRoute>} />
      <Route path="/tasks"              element={<ProtectedRoute><AppShell><GovernanceCapability /></AppShell></ProtectedRoute>} />
      <Route path="/audit-trail"        element={<ProtectedRoute><AppShell><GovernanceCapability /></AppShell></ProtectedRoute>} />
      <Route path="/alerts"             element={<ProtectedRoute><AppShell><GovernanceCapability /></AppShell></ProtectedRoute>} />

      {/* Consumer Intelligence future placeholders */}
      <Route path="/consumer-trust-profile" element={<ProtectedRoute><AppShell><ConsumerIntelligenceCapability /></AppShell></ProtectedRoute>} />
      <Route path="/behaviour-insights"     element={<ProtectedRoute><AppShell><ConsumerIntelligenceCapability /></AppShell></ProtectedRoute>} />

      {/* Institution Workspace future placeholders */}
      <Route path="/developer-portal"     element={<ProtectedRoute><AppShell><InstitutionWorkspaceCapability /></AppShell></ProtectedRoute>} />
      <Route path="/institution-settings" element={<ProtectedRoute><AppShell><InstitutionWorkspaceCapability /></AppShell></ProtectedRoute>} />

      {/* Consumer Education future placeholders */}
      <Route path="/education-certificates" element={<ProtectedRoute><AppShell><ConsumerEducationCapability /></AppShell></ProtectedRoute>} />
      <Route path="/campaigns"              element={<ProtectedRoute><AppShell><ConsumerEducationCapability /></AppShell></ProtectedRoute>} />
      <Route path="/education-analytics"    element={<ProtectedRoute><AppShell><ConsumerEducationCapability /></AppShell></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AccessibilityProvider>
            <TranslationProvider>
              <AppRouter />
            </TranslationProvider>
          </AccessibilityProvider>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
